import { Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  callAPI,
  clearRequest,
  Method
} from "../../commonFunctions/CommonFunctions";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import {
  HeaderList,
  IHeaderListActions
} from "../../Components/Header/HeaderList";
import WSSelectField from "../../Components/Select/WSSelect";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, {
  CurrencyType,
  TextType
} from "../../Components/TextBox/WSTextBox";
// import WSTimePicker from "../../Components/WSTimePicker/WSTimePicker";
import clientconfig from "../../Config/clientConfig.json";
import { WSIcons } from "../../commonFunctions/iIcons";

export const Service: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue } = useForm();
  const navigate = useNavigate();

  const params = useParams();
  const id = params?.id;
  const { showMessage } = useSnackbar();

  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getServiceById(id: any) {
      try {
        const response: any = await callAPI(
          "laundry-services",
          Method.GET,
          null,
          id
        );
        

        if (response && response?.data) {
          setValue("serviceName", response.data.serviceName);
          setValue("shortName", response.data.shortName);
          setValue("description", response.data.description);
          
          setValue("urgentServicePrice", response.data.urgentServicePrice);
          setValue("basePrice", response.data.basePrice);
          setValue("weightPrice", response.data.weightPrice);
          setValue(
            "estimatedCompletionTime",
            response.data.estimatedCompletionTime
          );
          setValue("timeType",response.data.timeType)
        }
      } catch (error) {
        console.error("failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      } 
    }
    if (id) {
      getServiceById(id);
    }
  }, [id, setValue]);


  const handleCancelClick = () => {
    navigate("/service/list");
  };

  /**
   * Method for Add/Update the data
   * @param data
   */

  const handleData = async (data: any) => {
    try {
      let request = {
        serviceName: data.serviceName,
        shortName: data.shortName,
        description: data.description,
        basePrice: data.basePrice,
        isWeightBased: data.isWeightBased,
        weightPrice: data.weightPrice,
        urgentServicePrice: data.urgentServicePrice,
        estimatedCompletionTime: data.estimatedCompletionTime,
        timeType:data.timeType,
      };

      const newRequest = clearRequest(request);

      const endpoint = id ? `laundry-services/${id}` : "laundry-services";

      const method = id ? Method.PUT : Method.POST;

      const response: any = await callAPI(endpoint, method, newRequest);

      if (response) {
        showMessage(
          response?.message,
          response.success === true ? "success" : "error"
        );
        response.success === true && navigate("/service/list");
      }
    } catch (e: any) {
      showMessage(e.message, "error");
    }
  };

  const actions: IHeaderListActions[] = [
    {
      type: "icon",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "error",
      icon: <WSIcons.CancelIcon />
    },
    {
      type: "icon",
      text: "Save",
      size: "small",
      buttonType: "submit",
      variant: "outlined",
      color: "success",
      icon: <WSIcons.SaveIcon />
    }
  ];

   
  return (
    <>
      <form onSubmit={handleSubmit(handleData)}>
        <HeaderList title="Add Service" type="card" actions={actions} />
        <Card sx={{ padding: 2, borderRadius: 2 }}>
          <Grid
            item
            container
            spacing={1}
            justifyContent={"start"}
            sx={{
              marginTop: 0,
              marginLeft: 0,
              width: "100%",
              backgroundColor: "#7D79C2",
              borderTopLeftRadius: 5,
              borderTopRightRadius: 5
            }}
          >
            <Grid
              alignContent={"center"}
              style={{ paddingLeft: 20, paddingTop: 0, height: "3rem" }}
              item
              sm={4}
              className="ws-data-grid-lightviolet-title"
            >
              <Typography
                variant="h6"
                id="tableTitle"
                sx={{ fontSize: "1rem" }}
              >
                Service Information
              </Typography>
            </Grid>
          </Grid>
          <Grid
            sx={{
              padding: 3,
              backgroundColor: "#fff",
              borderBottomLeftRadius: 5,
              borderBottomRightRadius: 5,
              border: "1px solid lightgrey"
              // marginTop: 3,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Service Name"}
                  rules={{ required: "Service Name is required" }}
                  id="serviceName"
                  name="serviceName"
                  control={control}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Short Service Name"}
                  rules={{ required: "Short Name is required" }}
                  id="shortName"
                  name="shortName"
                  control={control}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Description"}
                  id="description"
                  name="description"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Base Price"}
                  id="basePrice"
                  name="basePrice"
                  control={control}
                  rules={{ required: false }}
                  type={TextType.Currency}
                  currency={CurrencyType.Rupee}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Weight Price"}
                  id="weightPrice"
                  name="weightPrice"
                  control={control}
                  rules={{ required: false }}
                  type={TextType.Currency}
                  currency={CurrencyType.Rupee}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Urgent Service Price"}
                  id="urgentServicePrice"
                  name="urgentServicePrice"
                  control={control}
                  rules={{ required: false }}
                  type={TextType.Currency}
                  currency={CurrencyType.Rupee}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Enter Time"}
                  id="estimatedCompletionTime"
                  name="estimatedCompletionTime"
                  control={control}
                  rules={{ required: false }}
                  type={TextType.Number}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSSelectField
                  id="timeType"
                  label={"Select Time Type"}
                  name="timeType"
                  control={control}
                  options={clientconfig.timeType.staticOptionData}
                  rules={{ required: false }}
                />
              </Grid>

              <Grid item sm={6}>
                <WSSCheckBoxField
                  id="isWeightBased"
                  rules={{ required: false }}
                  name="isWeightBased"
                  control={control}
                  label={"Is Weight Based"}
                />
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </form>
    </>
  );
});
